/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputSystemPermission
 */
export interface InputSystemPermission {
    /**
     * 
     * @type {string}
     * @memberof InputSystemPermission
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InputSystemPermission
     */
    roles: Array<string>;
}

/**
 * Check if a given object implements the InputSystemPermission interface.
 */
export function instanceOfInputSystemPermission(value: object): boolean {
    if (!('description' in value)) return false;
    if (!('roles' in value)) return false;
    return true;
}

export function InputSystemPermissionFromJSON(json: any): InputSystemPermission {
    return InputSystemPermissionFromJSONTyped(json, false);
}

export function InputSystemPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputSystemPermission {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'roles': json['roles'],
    };
}

export function InputSystemPermissionToJSON(value?: InputSystemPermission | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'roles': value['roles'],
    };
}

